<app-modal class="!p-0 overflow-hidden">
  <div
    class="w-full min-w-[min(20rem,90vw)] bg-gradient-to-br from-lms-secondary via-white to-emerald-50 p-6 sm:min-w-[28rem] sm:p-8"
  >
    <div class="flex flex-col items-center text-center">
      <div
        [class]="
          isCritical()
            ? 'flex size-16 items-center justify-center rounded-full bg-red-100 text-4xl text-red-700'
            : 'flex size-16 items-center justify-center rounded-full bg-amber-100 text-4xl text-amber-700'
        "
      >
        <span
          class="iconify"
          data-icon="mdi:timer-sand"
          aria-hidden="true"
        ></span>
      </div>
      <h2 class="mt-5 text-xl font-bold tracking-tight text-slate-900">
        {{ header() }}
      </h2>
      <p class="mt-2 max-w-sm text-sm leading-6 text-slate-600">
        {{ body() }}
      </p>
      <div
        [class]="
          isCritical()
            ? 'mt-6 rounded-xl border border-red-200 bg-red-50 px-8 py-3 font-mono text-4xl font-bold tracking-wider text-red-700 shadow-sm'
            : 'mt-6 rounded-xl border border-amber-200 bg-amber-50 px-8 py-3 font-mono text-4xl font-bold tracking-wider text-slate-900 shadow-sm'
        "
        aria-label="Time remaining"
      >
        {{ displayMinutes() }}:{{ displaySeconds() }}
      </div>
      @if (loading()) {
        <div
          class="mt-8 flex items-center justify-center gap-3 text-sm font-semibold text-slate-600"
          role="status"
        >
          <i
            class="fa fa-spinner fa-spin text-xl text-lms-primary"
            aria-hidden="true"
          ></i>
          <span>Processing...</span>
        </div>
      } @else {
        <div
          class="mt-8 flex w-full flex-col-reverse items-stretch justify-between gap-3 sm:flex-row"
        >
          <button
            (click)="exit()"
            type="button"
            class="app-button app-button-outline border-red-700 text-red-700 sm:w-1/2"
          >
            {{ negativeButtonText() }}
          </button>
          <button
            (click)="refresh()"
            type="button"
            class="app-button app-button-primary sm:w-1/2"
          >
            {{ positiveButtonText() }}
          </button>
        </div>
      }
    </div>
  </div>
</app-modal>
